import React, { Component } from "react";
import TwoSamples from "./2samples";

//https://stackoverflow.com/questions/35352638/how-to-get-parameter-value-from-query-string
//http://localhost:3000/?page=lcs

class App extends Component {
	render() {
		// let page = new URLSearchParams(window.location.search).get("page");
		// console.log("page = " + page);

		var p = <TwoSamples />;
		// // if (page == "coin") {
		// // 	p = <Coin />;
		// // }
		// // else if (page == "lcs") {
		// // 	p = <LCS />;
		// // }
    
		return p;
	}
}

export default App;

//NOT WORK ===============

// https://p-library.com/p/tool/react1/sum
// https://p-library.com/p/tool/react1/index.html
// https://p-library.com/p/tool/react1/#/sum
// https://p-library.com/p/tool/react1/#/coin
// https://p-library.com/p/tool/react1/coin

// import { Link, Route, Switch } from "react-router-dom";
//https://codesandbox.io/s/nn8x24vm60?file=/index.js:27-135
//  "homepage": ".",
//   "homepage": ".",

// class App extends Component {
//   render() {
//     return (
//       <div>
//         <nav className="navbar navbar">
//           <ul className="nav">
//             <li>
//               <Link to="/">Home</Link>
//             </li>
//             <li>
//               <Link to="/coin">Coin</Link>
//             </li>
//             <li>
//               <Link to="/sum">Sum</Link>
//             </li>
//           </ul>
//         </nav>
//         <Switch>
//           <Route path="/coin" component={Coin} />
//           <Route path="/sum" component={Sum} />
//           <Route exact path="/lcs" component={LCS} />
//           <Route exact path="/" component={Coin} />
//         </Switch>
//       </div>
//     );
//   }
// }

// //Home component
// const Home = props => (
//   <div>
//     <h2>Home {console.log(props)}</h2>
//   </div>
// );

// const App = () => (
//     <main>
//       <Switch>
//         <Route exact path='/' component={Coin}/>
//         <Route path='/coin' component={Coin}/>
//         <Route exact path='/lcs' component={LCS}/>
//         <Route path='/sum' component={Sum}/>
//       </Switch>
//     </main>
//   )
